<!-- ToDo Michi: rework this altogether to be a more flexible grid for use in different scenarios -->
<div *ngIf="options && !selectedOption">
  <h3>Bitte wählen Sie {{ article }} {{ title }} aus</h3>
  <mat-grid-list [cols]="columns" gutterSize="2em" rowHeight="105:100">
    <mat-grid-tile *ngFor="let item of options">
      <button (click)="selectOption(item)" class="accessible-button">
        <h3>
          {{ item.displayName }}
        </h3>
        <img [src]="item.imgUrl" [attr.alt]="item.displayName" />
      </button>
    </mat-grid-tile>
  </mat-grid-list>

  <mat-error *ngIf="error">{{ title }} ist erforderlich</mat-error>
</div>

<div *ngIf="selectedOption">
  <h3>
    {{ selectedOption.displayName }}
  </h3>

  <div *ngIf="selectedOption.description" [innerHtml]="selectedOption.description | safeHtmlPipe"></div>

  <img class="image-to-show" [src]="selectedOption?.imgUrl" />

  <div *ngIf="!disable" class="action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <button
      mat-raised-button
      [disabled]="!canUpdate"
      color="primary"
      id="modal-confirm-button"
      (click)="changeOption()">
      {{ title }} ändern
    </button>
  </div>
</div>
